import React from 'react'
import './OptimizationThreshold.css';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSnackbar } from "notistack";
import DialogBox from "../../Dialog/Dialog.component";
import '../Table.css';


const useStyles = makeStyles({
  table: {
    width: "100% !important",
    maxWidth: "100% !important",
    margin: "0 !important",
  },
  button: {
    '&:hover': {
      backgroundColor: "rgba(29, 141, 12, 1)"
    },
    '&.Mui-disabled': {
      backgroundColor: "rgba(38, 184, 16, 0.5)"
    },
    backgroundColor: "rgba(38, 184, 16, 1)"
  },
  button1: {
    '&:hover': {
      backgroundColor: "rgba(19, 88, 7, 1)"
    },
    '&.Mui-disabled': {
      backgroundColor: "rgba(38, 184, 16, 0.5)"
    },
    backgroundColor: "rgba(19, 88, 7, 1)"
  },
  divider: {
    borderLeft: "1px solid",
    margin: "3px 15px",
    height: 18
  },
  topContent: {
    display: "flex",
    padding: "7px 10px",
    color: "#333",
    backgroundColor: "#ccc",
    fontFamily: "Arial",
    fontSize: "0.84rem",
    alignItems: "center"
  },
  values: {
    fontFamily: 'OpenSansBold',
    color: "#1172bd",
    fontSize: "0.9rem"
  }
});

function SimpleDialog(props) {
  const classes = useStyles();
  const { open, contentTypes, maxThreshold, metric, onClose, onSave, data, contentTypeMedium } = props;
  const [min, setMin] = React.useState({})
  const [max, setMax] = React.useState({})
  let validContentTypes = {};
  contentTypeMedium.contentTypeIds.forEach(el => {
    validContentTypes["contentType_" + el.contentTypeId] = el.enable === 0 ? false : true
  })
  const [validList, setValidList] = React.useState(validContentTypes)
  const { enqueueSnackbar } = useSnackbar();


  const handleClose = () => {
    onClose();
  };
  React.useEffect(() => {
    let minVal = {};
    let maxVal = {}
    if (data) {
      data.forEach(el => {
        minVal[el.contentType] = el.min
        maxVal[el.contentType] = el.max
      });
      setMin(minVal);
      setMax(maxVal);
    }
  }, [data])
  const modalMinChange = (event, key, index) => {
    let val = { ...min };
    val[key] = !isNaN(parseInt(event.target.value)) ? parseInt(event.target.value) : ""
    if (!isNaN(parseInt(event.target.value)) || event.target.value === "") {// && Object.values(val).reduce((a, b) => a + b, 0) <= maxThreshold
      // if (max[key] >= parseInt(event.target.value))
      setMin(val);
      // else
      //   enqueueSnackbar("Value of min must be less than or equals to max", {
      //     variant: "warning",
      //     autoHideDuration: 2000
      //   })
    }
    // else {
    //   enqueueSnackbar("Sum of all min must be less than or equals to " + maxThreshold, {
    //     variant: "warning",
    //     autoHideDuration: 2000
    //   })
    // }
  }

  const modalMaxChange = (event, key, index) => {
    if (!isNaN(event.target.value)) {
      let val = { ...max };
      val[key] = event.target.value === "" ? "" : parseInt(event.target.value);
      // if (min[key] === undefined || min[key] <= parseInt(event.target.value))
      setMax(val)
      // else
      //   enqueueSnackbar("Value of max must be greater than or equals to min", {
      //     variant: "warning",
      //     autoHideDuration: 2000
      //   })
    }
  }
  const validateMaxChange = (event, key, index) => {
    if (!isNaN(event.target.value) && parseInt(event.target.value) <= maxThreshold) {
      let val = { ...max };
      val[key] = parseInt(event.target.value);
      // if (min[key] === undefined || min[key] <= parseInt(event.target.value))
      setMax(val)
      // else
      //   enqueueSnackbar("Value of max must be greater than or equals to min", {
      //     variant: "warning",
      //     autoHideDuration: 2000
      //   })
    }
    else if (event.target.value != "") {
      enqueueSnackbar("Value of max must be less than or equals to " + maxThreshold, {
        variant: "warning",
        autoHideDuration: 2000
      })
    }
  }

  const handleSave = e => {
    let errored = false;
    let filledMin = [];
    let filledMax = []
    let outputContentTypes = contentTypes.filter(el => validList["contentType_" + el.contentTypeId]).map(contentType => {
      if (min[contentType.contentType] !== undefined && min[contentType.contentType] != -1 && min[contentType.contentType] !== "")
        filledMin.push(contentType)
      if (max[contentType.contentType] !== undefined && max[contentType.contentType] != -1)
        filledMax.push(contentType)
      let temp = {
        contentType: contentType.contentType,
        min: min[contentType.contentType] !== undefined && min[contentType.contentType] !== "" ? min[contentType.contentType] : -1,
        max: max[contentType.contentType] !== undefined && max[contentType.contentType] !== "" ? max[contentType.contentType] : -1
      }
      if (temp.max !== -1 && temp.min > temp.max)
        errored = true
      return temp
    })
    // let tempmin = Object.values(min).fliter(el => el > -1).reduce((a, b) => a + b, 0);
    // let tempmax = Object.values(max).filter(el => el > maxThreshold)
    if (Object.values(min).filter(el => el > -1).reduce((a, b) => a + b, 0) > maxThreshold) {
      enqueueSnackbar("Sum of all min must be less than or equals to " + maxThreshold, {
        variant: "warning",
        autoHideDuration: 2000
      })
    }
    else if (Object.values(max).filter(el => el > maxThreshold).length > 0) {
      enqueueSnackbar("Value of max must be less than or equals to " + maxThreshold, {
        variant: "warning",
        autoHideDuration: 2000
      })
    }
    else if (errored)
      enqueueSnackbar("Value of min must be less than or equals to max", {
        variant: "warning",
        autoHideDuration: 2000
      })
    else if (filledMin.length === 0 && filledMax.length === 0) {
      enqueueSnackbar("Need to enter atleast one value", {
        variant: "warning",
        autoHideDuration: 2000
      })
    }
    else {
      onSave(outputContentTypes);
      onClose();
    }
  }

  return (
    <DialogBox open={open} onClose={handleClose} onSave={handleSave} title={"Thresholds"}>
      <div>
        <div className={classes.topContent}>
          <div style={{ width: "50%" }}>Metric Selected: <span className={classes.values}>{metric ?.metricDisplayName}</span></div>
          <div className={classes.divider} />
          <div>Threshold: <span className={classes.values}>{maxThreshold}</span></div>
        </div>
        <TableContainer component={Paper} classes={{ root: classes.table }} style={{ marginTop: "20px", minWidth: 370, maxHeight: 300, maxWidth: "100% !important" }}>

          <Table stickyHeader className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow >
                {props.header.map((value, index) => {
                  return (<TableCell align={"center"} size='small' key={index}><b>{value}</b></TableCell>)
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {contentTypes.map((row, index) => (
                <TableRow key={index} style={{ backgroundColor: !validList["contentType_" + row.contentTypeId] ? "#d0d0d0 !important" : "" }}>
                  <TableCell size='small' align="left">
                    {row.contentTypeDisplayName}
                  </TableCell >
                  <TableCell size='small' align="center">
                    <input
                      type="text"
                      value={(min[row.contentType] !== undefined && min[row.contentType] != -1) ? min[row.contentType] : ""}
                      onChange={(event) => modalMinChange(event, row.contentType, index)}
                      disabled={!validList["contentType_" + row.contentTypeId]}
                    />
                  </TableCell>
                  <TableCell size='small' align="center">
                    <input
                      type="text"
                      value={(max[row.contentType] !== undefined && max[row.contentType] != -1) ? max[row.contentType] : ""}
                      disabled={!validList["contentType_" + row.contentTypeId]}
                      onBlur={(event) => validateMaxChange(event, row.contentType, index)}
                      onChange={(event) => modalMaxChange(event, row.contentType, index)} />
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </DialogBox>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function OptimizationThreshold(props) {

  const [open, setOpen] = React.useState(false);
  // const [selectedValue, setSelectedValue] = React.useState('');

  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    // setSelectedValue(value);
  };

  return (
    <div>
      <Button onClick={handleClickOpen} variant="contained" color="primary" disabled={props.disabled} classes={{ contained: props.data ? classes.button1 : classes.button }} style={{ color: "white", fontSize: "10px" }}>
        CONTENT TYPE THRESHOLDS
        </Button>
      {open && <SimpleDialog
        open={open}
        onClose={handleClose}
        {...props}
      />}

    </div>)
}
